export const ROUTE_PATH = '/parking-whitelist-p3';

export const FEATURE_NAME = 'parkingLevelThreeWhitelistPage';
